'use client'

import Link from 'next/link'
import { Image } from '~/components/ui/image'

interface LogoProps {
  isScrolled: boolean
}

export default function Logo({ isScrolled }: LogoProps) {
  const homePageUrl = process.env.NEXT_PUBLIC_PORTAL_URL || ''
  return (
    <Link
      href={`${homePageUrl}/vi`}
      className={`font-body font-lexend transition-colors ${
        isScrolled ? 'text-gray-900' : 'text-white'
      }`}
    >
      <Image
        src={isScrolled ? '/static/images/logo-black.png' : '/static/images/logo.png'}
        alt="MHG Logo"
        width={112}
        height={20}
        className="transition-opacity duration-300"
      />
    </Link>
  )
}
